import type { AlertColor } from '@mui/material/Alert';
import type { ReactNode } from 'react';
import type { NamedSet } from 'zustand/middleware';

import type { ZustandStore } from '../store.type';

export type NotificationType = {
	message: string | ReactNode;
	type: AlertColor | string;
	onClose?: () => void;
	timeout?: number;
};

type NotificationState = {
	notification: {
		alerts: NotificationType[];
	};
};

export type NotificationActions = {
	setNotification: (alerts: NotificationState['notification']['alerts']) => void;
};

export type NotificationSlice = NotificationState & NotificationActions;

const notificationInitialState: NotificationState = {
	notification: {
		alerts: [],
	},
};

export function notificationSlice(set: NamedSet<ZustandStore>): NotificationSlice {
	return {
		...notificationInitialState,
		setNotification(alerts: NotificationState['notification']['alerts']): void {
			set(
				(state: NotificationState) => {
					state.notification.alerts = alerts;
					return state;
				},
				false,
				'[setNotification]',
			);
		},
	};
}
